import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu/panel";
import { convertDataGroupIdToSet } from "common/query-builder/query-block/utils/data-group-util";
import { PropertyValuesScreenEl } from "./property-values-screen";
export function template() {
  const propertiesMenu = !this.state.propertyFilter.hasSelectedProperty() ? /* @__PURE__ */ jsx(PropertiesMenuEl, { onSelect: this.helpers.onPropertySelect, allDataGroups: this.attr("all-data-groups"), dataGroupIds: convertDataGroupIdToSet(this.attr("data-group-id")), eventNames: this.helpers.getEventNamesArray(), excludeDimensionProperties: this.attr("exclude-dimension-properties"), open: true, hideEvents: this.attr("hide-events"), projectHasPeople: this.attr("project-has-people"), projectId: this.attr("project-id"), showItemsCaret: true, workspaceId: this.attr("workspace-id"), descriptionEditDisabled: true }) : /* @__PURE__ */ jsx(PropertyValuesScreenEl, { attrs: this.helpers.filterAttributes({
    "display-context": this.attr("display-context"),
    "enable-enhanced-list-filters": this.attr("enable-enhanced-list-filters"),
    "event-names": this.helpers.getEventNames(),
    "property-filter": JSON.stringify(this.state.propertyFilter.getAttributes()),
    "has-back-button": true,
    "project-id": this.attr("project-id"),
    "workspace-id": this.attr("workspace-id")
  }), on: {
    clickBack: this.helpers.clickBackFromPropertyValues,
    changePropertyFilter: this.helpers.changePropertyFilter,
    commitPropertyFilter: this.helpers.commitPropertyFilter,
    draw: this.helpers.dispatchDraw
  }, keydownProxyEl: this.helpers.getKeydownProxyEl() });
  return /* @__PURE__ */ jsx("div", { sel: ".mp-property-filter-menu", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("no-drop-menu") || this.attr("open") ? propertiesMenu : !this.attr("no-drop-menu") ? /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: this.attr("open"),
    "prevent-close-selectors": this.attr("prevent-close-selectors")
  }, on: {
    change: this.helpers.changeDropMenu
  } }) : null);
}
